import { defineComponent as e } from "vue";
const s = e({
  name: "RExpandable",
  data() {
    return {
      isExpanded: !1
    };
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    }
  },
  render() {
    return this.$slots.default ? this.$slots.default({
      isExpanded: this.isExpanded,
      toggle: this.toggle
    }) : null;
  }
});
export {
  s as _
};
